import React, {useEffect, useRef, useState} from "react";

import Modal from "react-modal";
import styled from "styled-components";

import LoginButtonsComponent  from "../desktop/CardComponents/LoginButtonsComponent";

import { loginToTwitch, loginToYoutube } from "../../utils/loginHelper";

import CancelIcon from "../../assets/cancel_icon.svg";


const ConnectButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: static;
  width: 150px;
  height: 40px;
  cursor: pointer;
  background: #FFFFFF;
`

const ConnectButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`

const Address = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
`;


const Mobile = styled.div`
  display: none;
  background: #000;
  padding: 26px;
  padding-bottom: 0px;
  
  @media only screen and (max-device-width: 480px) {
  display: flex;
  /* height: 96vh; */
  flex-direction: row;
  }
`;

const Desktop = styled.div`
  display: none;
  background: #000;
  @media (min-device-width: 481px) {
  display: flex;
  flex-direction: column;
  /* height: 100vh; */
  height: 100%;
  /* overflow: hidden; */
  }
`;

const HeaderTextMobile = styled.span`
  font-family: 'IBM Plex Mono';
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: uppercase;
  color: #FFFFFF;
`


const customStylesMobile = {
    content: {
        background: "#0F0F0F",
	border:"none",
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: 351,
	height: 233,
        position:'relative'
    },
};

const customStylesDesktop = {
    content: {
        background: "#0F0F0F",
	border:"none",
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: 419,
        height: 239,
        position:'relative'
    },
};


export default function SocialConnectModalComponent(props){

    let modalWidth = "446px";
    let modalHeight = "330px";

    const [width, setWidth] = useState<number>(window.innerWidth);
    
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 768;

    
    const handleModalCloseEvent = ()=>{
	    props.setIsOpen(false);
    }

    
    return (
        <>
            {isMobile && (
                <Modal
                    style={customStylesMobile}
	            isOpen={props.isOpen}
                >
                    <img onClick={()=>{handleModalCloseEvent()}}
		         src={CancelIcon}
		         style={{
			     position: "absolute", opacity: 0.4,
			     height: 14, width:14,
			     right:10, cursor:"pointer",
			     zIndex:10
		         }}
		    />
                    <div style={{
                        display:'flex',
                        justifyContent:'center',
                        alignItems:'center',
                    }}>
                        <HeaderTextMobile>
                            LOGIN THROUGH<br/>
                            SOCIAL NETWORKS
                        </HeaderTextMobile>
                    </div>
                    <div style={{marginTop:23}}>
                        <LoginButtonsComponent
                            width={319}
                        >
                        </LoginButtonsComponent>
                    </div>
                </Modal>
            )}
            {!isMobile && (
                
                <Modal
                    style={customStylesDesktop}
	            isOpen={props.isOpen}
                >
                    <img onClick={()=>{handleModalCloseEvent()}}
		         src={CancelIcon}
		         style={{
			     position: "absolute", opacity: 0.4,
			     height: 14, width:14,
			     right:10, cursor:"pointer",
			     zIndex:10
		         }}
		    />
                    <div style={{
                        display:'flex',
                        justifyContent:'center',
                        alignItems:'center',
                    }}>
                        <HeaderTextMobile>
                            LOGIN THROUGH<br/>
                            SOCIAL NETWORKS
                        </HeaderTextMobile>
                    </div>
                    <div style={{marginTop:23}}>
                        <LoginButtonsComponent
                            width={371}
                        >
                        </LoginButtonsComponent>
                    </div>
                </Modal>
            )}
        </>
    );
}
